import { all, takeLatest } from 'redux-saga/effects';

import { send } from '../../slices/leadMagnetForm';
import leadMagnetFormWorker from './leadMagnetFormWorker';

export default function* watchLeadMagnetForm() {
  yield all([takeLatest([send], leadMagnetFormWorker)]);
}
